module.exports = __webpack_public_path__ + "static/media/stoop.d07caae4.jpg";